import 'rxjs/add/operator/shareReplay';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from 'ng2-translate';
import { GuestService } from './guest.service';

export enum LanguagesEnum {
  English = 'en',
  Hungarian = 'hu',
  Romanian = 'ro',
}

const LanguageNames: { [key: string]: string } = {
  [LanguagesEnum.English]: 'English',
  [LanguagesEnum.Hungarian]: 'Magyar',
  [LanguagesEnum.Romanian]: 'Română',
};

const defaultLang = LanguagesEnum.English;

@Injectable()
export class LanguageService {
  currentLanguage$: Observable<LanguagesEnum>;
  private _currentLanguage = new BehaviorSubject<LanguagesEnum>(defaultLang);

  constructor(private ts: TranslateService, private gs: GuestService) {
    this.currentLanguage$ = this._currentLanguage.shareReplay(1);
    this.ts.setDefaultLang(defaultLang);

    this.gs.getLanguage().then(lang => {
      if (lang) {
        this._currentLanguage.next(lang as LanguagesEnum);
        this.ts.use(lang);
      }
    });
  }

  switchTo(lang: LanguagesEnum) {
    this._currentLanguage.next(lang);
    this.ts.use(lang);
    this.gs.updateLanguage(lang);
  }

  getLanguages(): { code: LanguagesEnum; name: string }[] {
    const result = [];
    for (const key of Object.keys(LanguagesEnum)) {
      const code = LanguagesEnum[key];
      if (code !== this._currentLanguage.getValue()) {
        result.push({
          code,
          name: this.getLanguageName(code as LanguagesEnum),
        });
      }
    }
    return result;
  }

  getLanguageName(lang?: LanguagesEnum): string {
    const _lang = (lang || this._currentLanguage.getValue()) as string;
    return LanguageNames[_lang];
  }

  getFlag(lang?: LanguagesEnum): string {
    const _lang = lang || this._currentLanguage.getValue();
    return 'flag-' + _lang;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts